"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.UserProfileSubCategory = (0, type_utils_1.makeEnum)({
    /** A link to an individual's profile picture */
    ProfilePictureURL: 'PROFILE_PICTURE_URL',
    /** An individual's profile picture */
    ProfilePictureImage: 'PROFILE_PICTURE_IMAGE',
    /** The user's stated preferences while using an app */
    UserPreferences: 'USER_PREFERENCES',
    /** Fallback subcategory */
    UserProfile: 'USER_PROFILE',
});
//# sourceMappingURL=userProfile.js.map